import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { param } from 'jquery';
import { isNil } from 'lodash-es';
import { ApiService } from 'src/app/api/api.service';
import { Paginador, Parametros, Perfil, Result } from 'src/app/shared/interfaces';
@Component({
    selector: 'nominacion-carrusel',
    templateUrl: './nominacion-carrusel.component.html',
    styleUrl: './nominacion-carrusel.component.scss'
})
export class NominacionCarruselComponent implements OnInit, OnChanges {

    @Input() titulo: string = "";
    @Input() campoFiltro: string = "id";
    @Input() filtroAscendente: boolean = false;
    @Input() grid: boolean = false;
    @Input() categoriaId: number = -1;
    @Input() periodoId: number = -1;
    @Input() buscarPeriodo: boolean = false;
    @Input() ultimoPeriodo: number = -1;
    @Input() finalista: boolean = false;
    @Input() tipoConsulta: string = 'nuevasNominaciones';
    @Input() perfilActualId: number = -1;
    @Input() ganador: boolean = false;
    @Input() busqueda: string = "";
    private _perfiles: Perfil[] = [];
    private _paginador: Paginador | any = null;
    private _paginas: number[] = [];
    private _seleccionada: number = 1;
    private _filtroMasVotados: boolean = false;
    constructor(private domSanitizer: DomSanitizer, private api: ApiService) {

    }

    ngOnChanges(changes: SimpleChanges): void {
        switch (this.tipoConsulta) {
            case 'nuevasNominaciones':
                this.buscarNuevas()
                break;
            case 'masVotados':
                this.masVotados()
                break;
            default:
                break;
        }
    }

    ngOnInit(): void {
        switch (this.tipoConsulta) {
            case 'nuevasNominaciones':
                this.buscarNuevas()
                break;
            case 'masVotados':
                this.masVotados()
                break;
            default:
                break;
        }
    }

    ordenarMasVotados() {
        this._filtroMasVotados = !this._filtroMasVotados;
        this.buscarNuevas();
    }

    async buscarNuevas(pagina: number = 1) {
        try {
            let paginador = { pagina: pagina, limite: 8 }
            const params: Parametros[] = [];

            if (this.grid) {
                params.push({ param: 'limite', valor: paginador.limite.toString() }, { param: 'page', valor: paginador.pagina.toString() })
            } else {
                params.push({ param: 'finalista', valor: this.finalista ? 'si' : 'no' })
                params.push({ param: 'ganador', valor: this.ganador ? 'si' : 'no' })
            }

            if (!isNil(this.busqueda) && this.busqueda != '') {
                params.push({ param: 'nominado', valor: this.busqueda })
            }

            if (this.buscarPeriodo) {
                params.push({ param: 'periodoId', valor: this.periodoId.toString() })
                params.push({ param: 'ganador', valor: 'si' })
                this.ganador = true;
            }

            const tipo = !this._filtroMasVotados ? 'nuevos' : 'masvotados';
            const categoriaId = this.categoriaId
            const path = `/nominados/list/${tipo}/${categoriaId}`
            const result = (await this.api.consulta(path, false, params, {}, 'GET')).data
            const objetoResult = (isNil(result.data) ? result : result.data) as Result
            this._perfiles = objetoResult.data;
            this._paginador = objetoResult.meta;
            this.calcularPaginas();
        } catch (error) {
            console.log(error)
        }
    }

    async masVotados() {
        try {
            const tipo = 'masvotados'
            const categoriaId = this.categoriaId
            const path = `/nominados/list/${tipo}/${categoriaId}`
            const result = (await this.api.consulta(path, false, [], {}, 'GET')).data as Result
            const objetoResult = (isNil(result.data) ? result : result.data) as Result
            this._perfiles = objetoResult.data;
            this._paginador = objetoResult.meta;
        } catch (error) {
            console.log(error)
        }
    }

    calcularPaginas() {
        this._paginas = [];
        this._seleccionada = this._paginador.current_page;
        let paginas = this._paginador.total / this._paginador.per_page;
        for (let i = 0; i < paginas; i++) {
            this._paginas.push(i + 1);
        }
    }

    get perfiles(): Perfil[] {
        return this._perfiles.filter(perfil => perfil.id !== this.perfilActualId);
    }

    get paginador(): Paginador {
        return this._paginador;
    }

    get paginas(): number[] {
        return this._paginas;
    }

    get seleccionada(): number {
        return this._seleccionada;
    }

    get filtroMasVotados(): Boolean {
        return this._filtroMasVotados;
    }

}